import { ReferralExperiment } from '../../types/referrals';

const EXPERIMENT_NAME_PREFIX = 'EXPERIMENT_NAME_';
const UNSET_NAME = 'EXPERIMENT_NAME_UNSET';

export function buildExperimentVariant(
  activeExperiments?: ReferralExperiment[],
): string {
  if (!activeExperiments?.length) return 'v2';

  const experimentParts = activeExperiments
    .filter(exp => {
      const name = String(exp.experimentName ?? '');
      return name !== '' && name !== UNSET_NAME;
    })
    .sort((a, b) =>
      String(a.experimentName).localeCompare(String(b.experimentName)),
    )
    .map(exp => {
      const raw = String(exp.experimentName);
      const name = raw.startsWith(EXPERIMENT_NAME_PREFIX)
        ? raw.slice(EXPERIMENT_NAME_PREFIX.length)
        : raw;
      return `${name} | ${exp.experimentArm}`;
    })
    .join(', ');

  if (!experimentParts) return 'v2';

  return `v2 | ${experimentParts}`;
}
